module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "drag": _vm.drag,
      "action": _vm.action,
      "data": _vm.formData,
      "limit": _vm.limit,
      "accept": _vm.accept,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "disabled": _vm.disabled,
      "show-file-list": _vm.showFileList
    }
  }, [(_vm.preview && _vm.currentValue) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.currentValue
    }
  }) : _c('div', [_vm._t("default", [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "el-upload__tip"
  }, [_vm._t("tip")], 2)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a813f0c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-image-uploader.vue
// module id = 309
// module chunks = 0